import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { APP_ROUTES } from '../../../contants/APP_ROUTES';
import { PARAMS } from '../../../contants/PARAMS';
import { QUERY_PARAMS } from '../../../contants/QUERY_PARAMS';
import { DateHelper } from '../../../helpers/DateHelper';
import { Helper } from '../../../helpers/Helper';
import { CashAdvance } from '../../../models/cashAdvances/cash.advance';
import { CashAdvanceFilter } from '../../../models/cashAdvances/cash.advance.filter';
import { PageOption } from '../../../models/common/pageOption';
import { Row } from '../../../models/tables/row';
import { AlertService } from '../../../services/alert.service';
import { BudgetService } from '../../../services/budget.service';
import { CashAdvanceService } from '../../../services/cash-advance.service';
import { ParameterService } from '../../../services/parameter.service';

@Component({
  selector: 'app-cash-advance-list',
  templateUrl: './cash-advance-list.component.html',
  styleUrls: ['./cash-advance-list.component.css']
})
export class CashAdvanceListComponent implements OnInit {
  	pageOption: PageOption<CashAdvanceFilter> = new PageOption();
	
	rows: Row<CashAdvance>[] = [];
	budget: number;	

	constructor(
		private _cashAdvanceService: CashAdvanceService,
		private _alertService: AlertService,
		private _parameterService: ParameterService,
		private _router: Router,
		private _activatedRoute: ActivatedRoute,
		private _budgetService: BudgetService
	) { }

	ngOnInit() {
		this.pageOption.searchFilter = new CashAdvanceFilter();
		this.getBudget();
		
		this._activatedRoute.queryParams.subscribe(
			params => {
				var filter = new CashAdvanceFilter();
				if(params[QUERY_PARAMS.IS_DATE_NOW] != 'false'){
					filter.createdDateFrom = DateHelper.getDateNowString();
					filter.createdDateTo = DateHelper.getDateNowString();
				}

				this._parameterService.getCachedParameter<number>(PARAMS.CASH_ADVANCE_TABLE_DEFAULT_PAGE_SIZE, 3600).subscribe(
					value => {
						value = Number(value);
						this.pageOption.pageSize = isNaN(value) || value == 0 ? 50 : value;
						this.pageOption.pageNumber = 1;
		
						this.search(filter);
					}
				);
			}
		);
	}

	fetchData(){
		this._cashAdvanceService.getCashAdvanceList(this.pageOption).subscribe(
			result => {
				if (result.data != undefined) {
					if(this.pageOption.pageTotal <= 0){
						this.pageOption.pageTotal = result.totalPages;
					}

					let index = ((result.pageNumber - 1) * this.pageOption.pageSize);
					result.data.forEach(x => {
						let row = new Row<CashAdvance>();
						row.status = 'loaded';
						row.object = x;
						this.rows[index] = row;
						index++;
					});
				}
			}
		);
	}

	onFetchNextData(pageNumber: number){
		this.pageOption.pageNumber = pageNumber;
		this.fetchData();
	}

	saveRow(index: number) {
		let cashAdvance = this.rows[index].object;

		if (cashAdvance.id == undefined || cashAdvance.id == 0) {
			this.createCashAdvance(index, cashAdvance);
		}
		else {
			this.updateCashAdvance(index, cashAdvance);
		}
	}

	addRow() {
		let row = new Row<CashAdvance>();
		row.status = 'new';
		row.object = new CashAdvance();
		row.object.id = 0;
		row.object.dateRecieved = DateHelper.getDateNowString();
		row.object.releasedById = Helper.currentUserId();
		row.object.createdDate = DateHelper.getDateNowString();

		this.rows.push(row);
	}

	removeRow(index: number){
		let id = this.rows[index].object.id;
		this.rows.splice(index, 1);

		//call delete
		if(id != 0){
			this._cashAdvanceService.deleteCashAdvance(id).subscribe(
				result => {
					if(result == undefined){
						this._alertService.showGenericError();
					}
					else if(result.errors.length > 0){
						this._alertService.displayErrorResult(result);
					}
				}
			);
		}
	}

	goToFormView(id: number){
		this._router.navigate([APP_ROUTES.cashAdvanceForm.replace('/:id', ''), id]);
	}

	search(filter: CashAdvanceFilter) {
		if(filter != null){
			this.pageOption.searchFilter.dateRecievedFrom = filter.dateRecievedFrom;
			this.pageOption.searchFilter.dateRecievedTo = filter.dateRecievedTo;
			this.pageOption.searchFilter.recieverId = filter.recieverId;
			this.pageOption.searchFilter.releasedById = filter.releasedById;
			this.pageOption.searchFilter.createdDate = filter.createdDate; //date filed
			this.pageOption.searchFilter.createdDateFrom = filter.createdDateFrom; 
			this.pageOption.searchFilter.createdDateTo = filter.createdDateTo; 
			this.pageOption.searchFilter.createdBy = filter.createdBy;
			this.pageOption.searchFilter.updatedDate = filter.updatedDate;
			this.pageOption.searchFilter.updatedBy = filter.updatedBy;
		}

		this.rows = []; //reset array
		this.fetchData();
	}

	private createCashAdvance(index: number, newCashAdvance: CashAdvance) {
		this._cashAdvanceService.addCashAdvance(newCashAdvance).subscribe(result => {
			if (result.object != undefined) {
				this.updateObject(index, result.object);
				this._alertService.showSuccess('Cash Advance information has been saved.')
			}
			else {
				this.rows[index].hasError = true;
				this._alertService.displayErrorResult(result.errorCollection);
			}
		});
	}

	private updateCashAdvance(index: number, existingCashAdvance: CashAdvance) {
		this._cashAdvanceService.updateCashAdvance(existingCashAdvance).subscribe(result => {
			if (result.object != undefined) {
				this.updateObject(index, result.object);
				this._alertService.showSuccess('Cash Advance information has been updated.');
			}
			else {
				this.rows[index].hasError = true;
				this._alertService.displayErrorResult(result.errorCollection);
			}
		});
	}

	private updateObject(index: number, object: CashAdvance){
		this.rows[index].object = object;
		this.rows[index].hasError = false;
		this.getBudget();
	}

	getTotal(){
		let totalAmount = 0;
		this.rows.forEach(row => {
			let value = Number(row.object.amount);
			totalAmount += isNaN(value) ? 0 : value;
		})

		return totalAmount;
	}

	private getBudget(){
		this._budgetService.getTotalBudget().subscribe(
			result => {
				if(result != undefined){
					this.budget = result;
				}
			}
		);
	}
}



// WEBPACK FOOTER //
// ./src/app/components/cashAdvances/cash-advance-list/cash-advance-list.component.ts